import { Traveler } from '@marageti/z4-sdk/lib/people';
import { TripMatch, TripRequest } from '@marageti/z4-sdk/lib/travel';

export const getChipsFromTripMatch = (tripMatch: TripMatch, statusFirst = true) => {
  const primaryTraveler = tripMatch.travelers[0];
  const chips = [];

  // Status
  if (statusFirst) chips.push(tripMatch.status);

  // Tags
  if (primaryTraveler?.tags) {
    primaryTraveler.tags.forEach((tag: string) => {
      chips.push(tag);
    });
  }

  // Referral Type
  if (tripMatch.referralType) chips.push(tripMatch.referralType);

  //  Repeat Traveler
  if (tripMatch.repeatTraveler) chips.push('REPEAT_TRAVELER');

  // Status
  if (!statusFirst) chips.push(tripMatch.status);

  return chips;
};

export const getChipsFromTripRequest = (tripRequest: TripRequest, statusFirst = true, hasNewMessage = false) => {
  const primaryTraveler = tripRequest.travelers[0];
  const chips = [];

  // Status
  if (statusFirst) chips.push(tripRequest.status);

  // Tags
  if (primaryTraveler?.tags) {
    primaryTraveler.tags.forEach((tag: string) => {
      chips.push(tag);
    });
  }

  //  Repeat Traveler
  if (tripRequest.repeatTraveler) chips.push('REPEAT_TRAVELER');

  // Referral Type
  if (tripRequest.referralType) chips.push(tripRequest.referralType);

  // Status
  if (!statusFirst) chips.push(tripRequest.status);

  if (hasNewMessage) chips.push('NEW_MESSAGE');

  return chips;
};

export const getChipsFromTraveler = (traveler: Traveler) => {
  const chips = [];

  // Tags
  if (traveler.tags) {
    traveler.tags.forEach((tag: string) => {
      chips.push(tag);
    });
  }

  //  Status
  if (traveler.userInfo[0].status) chips.push(traveler.userInfo[0].status);

  //  Repeat Traveler
  if (traveler.totalZicassoTrips > 0) chips.push('REPEAT_TRAVELER');

  return chips;
};
